import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";

export const selectorIsRequirementArchived = (
  requirement: IRequirementResponse
) => {
  return (
    !requirement.payerPayeeEngagementIds ||
    requirement.payerPayeeEngagementIds.length === 0
  );
};
